import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

// Starts a WorkOS login as soon as it loads. This is the sign-in URL registered in the WorkOS
// dashboard: WorkOS sends the browser here to begin a login it initiates itself, such as when
// support staff impersonate a user. Unlike the login page, it starts one whatever happened before.
@Component({
  selector: 'app-auth-start',
  templateUrl: './auth-start.component.html',
  styleUrls: ['../../main/main.component.scss', '../auth-callback/auth-callback.component.scss'],
})
export class AuthStartComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.authService.getAuthorizationUrl().subscribe(
      () => { /* AuthService has sent the browser to WorkOS */ },
      () => this.router.navigate(['login'])
    );
  }
}
